// extracted by mini-css-extract-plugin
export default {"container":"header_container__BxV9m","logo":"header_logo__q8B9l","navDiv":"header_navDiv__4sTKV","notificationDiv":"header_notificationDiv__gYtAQ"};